<ng-container *ngIf="!isLoading">
  <div
    class="offers-last__item"
    (click)="!isModalOpened ? openDetail() : ''"
    [ngClass]="{
      trashold:
        campaign.customProperties?.dataPoint ? shouldGreyscale : (campaign.isTrashold || campaign.status === drawingEventStatus.Approved)
    }"
    [ngStyle]="
      styleService.getStyleRule(
        undefined,
        [tab.configurations.cardOffer.background],
        [
          tab.configurations.cardOffer.border,
          mainTemplate.globalVariables.borders
        ]
      )
    "
  >
    <div 
      class="offers-last__item-img-wrapper"
      [ngClass]="{
        greyscale:
          campaign.customProperties?.dataPoint ? shouldGreyscale : (campaign.isTrashold || campaign.status === drawingEventStatus.Approved)
      }"
    >
      <img
        [src]="
          !displayRewardImageAfterReveal
            ? campaign.imageUrl
            : (campaign.knownReward
            ? campaign.knownReward.isMystery
              ? campaign.knownReward.mysteryConfig?.imageUrl
              : campaign.knownReward.imageUrl
            : campaign.imageUrl)
        "
        class="btn-ico"
      />
    </div>
    <div class="offers-last__item-content">
      <h3
        class="offers-last__item-name"
        [ngClass]="{
          greyscale:
            campaign.customProperties?.dataPoint ? shouldGreyscale : (campaign.isTrashold || campaign.status === drawingEventStatus.Approved)
        }"
        [ngStyle]="
          styleService.getStyleRule([
            tab.configurations.cardOffer.title,
            undefined,
            'heading4'
          ])
        "
      >
        {{
          !displayRewardImageAfterReveal
            ? campaign.title
            : (campaign.knownReward
            ? campaign.knownReward.isMystery
              ? campaign.knownReward.mysteryConfig?.name
              : campaign.knownReward.name
            : campaign.title)
            | conditionalUppercase
              : styleService.getUppercaseValue(
                  tab.configurations.cardOffer.title
                )
        }}
      </h3>
      <div 
        class="offers-last__item-content-bottom"
        [ngClass]="{
          greyscale: campaign.customProperties?.dataPoint ? shouldGreyscale : campaign.isTrashold
        }"
      >
        <div class="offers-last__item-line"></div>
        <div *ngIf="thresholdPassed">
          <button
            class="offers-last__item-btn"
            [ngStyle]="
              styleService.getStyleRule(
                [tab.configurations.cardOffer.buttonOfferDetails.text],
                [tab.configurations.cardOffer.buttonOfferDetails.background],
                [tab.configurations.cardOffer.buttonOfferDetails.border]
              )
            "
          >
            {{
              tab.configurations.cardOffer.buttonOfferDetailsText
                ? tab.configurations.cardOffer.buttonOfferDetailsText
                : ("Offer detail"
                  | conditionalUppercase
                    : styleService.getUppercaseValue(
                        tab.configurations.cardOffer.buttonOfferDetails.text
                      ))
            }}
          </button>
        </div>
        <div *ngIf="!thresholdPassed && displayProgressionStatus">
          <button
            class="offers-threshold-btn"
          >
            {{ pointsEarnedToday }} out of {{ pointsThreshold }} {{ dataPoint }}
          </button>
          <p></p>
        </div>
      </div>
    </div>
  </div>
</ng-container>
